import Fetch from 'lib/store/middleware/api/fetch/Fetch';

// import woflow from './interceptors/woflow';
import pos from './interceptors/pos';

const fetch = new Fetch();

// install interceptors
// see history for examples to mock intercepted requests

// fetch.intercept('/api/menus/import_woflow_menus', woflow);
fetch.intercept('/api/menus/get_pos_details', pos);

export default (...args) => fetch.fetch(...args);
